<template>
	<div class="alert" :class="classes" v-if="visible">
		<div :class="{'right-margin': !unclosable}" class="inner" v-on:click="alertClick">
			<i v-if="icon" class="fa fa-fw" :class="icon"></i>
			<span v-html="message"></span>
			<ul v-if="errors && (Object.keys(errors).length > 1 || errors.length > 1)">
				<li v-for="error in Object.keys(errors)">{{ errors[error] }}</li>
			</ul>
			<div v-else-if="errors && errors.length == 1">{{errors[0]}}</div>
			<slot></slot>
		</div>
		<button v-if="buttonText || buttonIcon" type="button" class="btn" :class="buttonClass" v-on:click="$emit('buttonClick')">
			<i class="fa" :class="buttonIcon"></i>
			{{buttonText}}
		</button>
		<button v-if="!unclosable" type="button" class="close" v-on:click="dismiss" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
</template>

<script>

export default {

	name: 'Alert',

	props: [
		"unclosable",
		"classes",
		"visible",
		"errors",
		"message",
		"icon",
		"selfClear", //if set to True, alert will self close itself in 3 seconds
		"buttonClass",
		"buttonText",
		"buttonIcon"
	],
	data() {
		return {
			closeDelay: 3000
		}
	},
	methods: {
		dismiss() {
			this.$emit("close")
		},
		alertClick() {
			this.$emit("click")
		}
	},
	created() {
		if (this.selfClear) {
			let vm = this

			setTimeout(function(){
				vm.$emit("close")
			},vm.closeDelay)
		}
	}
}
</script>

<style type="text/css" scoped>
	div.alert {
		margin-bottom: 5px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	.right-margin {
		margin-right: 20px;
	}

	.inner {
		flex-grow: 1
	}

	button.close {
		position: absolute;
		top: 0px;
		right: 5px;
		padding: 5px;
	}
</style>